import type { TilesetId } from '@ponponland/shared';

/** Public asset root for each tileset region's pngs (tiles/objects/bg). */
export const TILESET_ROOTS: Record<TilesetId, string> = {
  sunnyland: '/assets/tilesets/sunnyland',
  icezone: '/assets/tilesets/icezone',
} as const;

/** Re-export the shared cosmetic tileset id so client code has one source. */
export type { TilesetId };

/** The default tileset a stage renders with when its def omits `tileset`. */
export const DEFAULT_TILESET: TilesetId = 'sunnyland';

